/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { B3Propagator } from './B3Propagator';
export {
  B3_CONTEXT_HEADER,
  X_B3_FLAGS,
  X_B3_PARENT_SPAN_ID,
  X_B3_SAMPLED,
  X_B3_SPAN_ID,
  X_B3_TRACE_ID,
} from './constants';
export { B3InjectEncoding } from './types';
export type { B3PropagatorConfig } from './types';
